<template>
  <div class="list-cards console-command-list">
    <div
      v-for="mailing in mailingCards"
      :key="mailing.title"
      class="card-management-list"
      :class="`mailing-${mailing.title.toLowerCase()}`">
      <mailing-card
        :title="mailing.title"
        :action-for-get-data="getMailing"
        :action-for-update-data="editMailing"
        :mailing-list="mailing.mailingList"
        :url="mailing.url"/>
    </div>
    <div
      v-for="(command, index) in commandsCards"
      :key="command.alias"
      class="card-management-list"
      :class="[`command-${command.alias}`, {'last-command-card': isOddCards && commandsCards.length - 1 === index}]">
      <command-card
        :card="command"
        :commands="consoleCommands ? consoleCommands[command.alias] : undefined"/>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import '@/assets/sass/style/components/pages/settings/switchCard.scss'
import MailingCard from '@/components/Pages/Settings/MailingCard'
import CommandCard from '@/components/Pages/Settings/CommandCard'

export default {
  name: 'ConsoleCommands',
  components: {
    MailingCard,
    CommandCard
  },
  computed: {
    ...mapGetters({
      consoleCommands: 'superadministrator/consoleCommands',
      smsMailing: 'superadministrator/smsMailing',
      emailMailing: 'superadministrator/emailMailing'
    }),
    mailingCards() {
      return [
        {
          title: 'SMS',
          mailingList: this.smsMailing,
          url: 'admin/sms-services'
        },
        {
          title: 'Email',
          mailingList: this.emailMailing,
          url: 'admin/domain-mailers'
        }
      ]
    },
    commandsCards() {
      return [
        {
          title: 'Проверки',
          alias: 'check'
        },
        {
          title: 'Уведомления',
          alias: 'notifications'
        },
        {
          title: 'Марафон',
          alias: 'marathon'
        },
        {
          title: 'Активация марафона',
          alias: 'marathon-activate'
        },
      ]
    },
    isOddCards() {
      return this.commandsCards.length % 2 !== 0
    }
  },
  methods: {
    ...mapActions({
      getConsoleCommands: 'superadministrator/getConsoleCommands',
      getMailing: 'superadministrator/getMailing',
      editMailing: 'superadministrator/editMailing'
    })
  },
  async beforeMount() {
    await this.getConsoleCommands()
  }
}
</script>

<style scoped>

</style>
